import React, {
  memo,
  useCallback,
  useEffect,
  useState,
  useSyncExternalStore
} from "react";

// import Slider, { sliderClasses } from '@mui/joy/Slider';

import { HOUR, SECOND } from "@graphic/constants";
import useSlider from "@graphic/hooks/overlay/use-slider";

import {
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Box,
  Tooltip
} from "@chakra-ui/react";

const TimeSlider = () => {
  const {
    sliderValue,
    minTime,
    marks,
    handleSliderChange,
    valueLabelFormat,
    timelength
  } = useSlider();

  const [showTooltip, setShowTooltip] = useState(false);

  if (!minTime) return null;

  return (
    <Box padding={"2rem 3rem 2rem 3rem"} pointerEvents={"auto"}>
      <Slider
        aria-label="time-slider"
        // defaultValue={0}
        value={sliderValue}
        onChange={val => handleSliderChange(val)}
        min={minTime.valueOf()}
        max={minTime.add(timelength - 1, "hour").valueOf()}
        step={SECOND}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        focusThumbOnChange={false}
      >
        <SliderTrack bg="whitesmoke" height={"0.3rem"} borderRadius={"0.3rem"}>
          <SliderFilledTrack bg="whitesmoke" />
        </SliderTrack>

        <Tooltip
          hasArrow
          bg="#636B74"
          padding="0.3rem"
          borderRadius="0.3rem"
          color="white"
          placement="top"
          isOpen={true} // TODO: showTooltip
          label={valueLabelFormat(sliderValue)}
        >
          <SliderThumb
            boxSize={3}
            transform={`translateY(-50%)`}
            bg="blue"
            borderRadius={"50%"}
            boxShadow={"0 0 0 2px white"}
          />
        </Tooltip>

        {marks.map(mark => (
          <SliderMark
            key={mark.value}
            value={mark.value}
            mt="2"
            fontSize="sm"
            transform={`translateX(-50%)`}
          >
            {mark.label}
          </SliderMark>
        ))}
      </Slider>
    </Box>
  );
};

export default memo(TimeSlider);
